import "./inviteUsers.css"

import { EnhancedDropDown, EnhancedMultiDropDownRHF, EnhancedMultiDropDownRHFWithLabel, LabelPosition, RHookFormTextFieldWithLabel, ResetButton, SubmitButton, SubmitButtonVariant } from '@websential/cosmic';
import { FormProvider, useForm } from 'react-hook-form';
import React, { useCallback, useEffect, useRef, useState } from 'react';

import { Box } from '@mui/material';
import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Dropdown } from 'primereact/dropdown';
import { InviteUsersSchema } from './validator';
import PlaylistAddCheckOutlinedIcon from "@mui/icons-material/PlaylistAddCheckOutlined";
import { Rating } from 'primereact/rating';
import { Tag } from 'primereact/tag';
import { Toast } from 'primereact/toast';
import { isEqual } from "lodash";
import { yupResolver } from '@hookform/resolvers/yup';

export interface IInviteUsersDataTable {
  rows: any[];
  columns: any[];
  clientHeaderColumns: any[];
  roles: any;
  timeProfiles: any;
  isLoading?: boolean;
  onDataSubmit: (value: any) => void
}
export const InviteUsersDataTable: React.FC<IInviteUsersDataTable> = ({
  rows,
  columns,
  clientHeaderColumns,
  roles,
  timeProfiles,
  isLoading,
  onDataSubmit
}) => {
  const [selectedItems, setSelectedItems] = useState<any>([]);
  const [tableData, setTableData] = useState<any>(rows && rows);
  const [subtableData, setSubTableData] = useState<any>(null);
  const [selectedSubItems, setSelectedSubItems] = useState<any>([]);
  const [formSubmitted, setFormSubmitted] = useState(false);

  const [expandedRows, setExpandedRows] = useState<any>(null);
  const [errorClass, setErrorClass] = useState(false);
  const toast = useRef<any>(null);

  useEffect(() => {
    if (rows) {
      setTableData(rows)
    }
  }, [rows])

  const allowExpansion = (rowData: any) => {

    return rowData && rowData.children && rowData.children.length > 0;
  };
  const formMethods: any = useForm<any>({
    resolver: yupResolver(InviteUsersSchema),
    mode: "onBlur",
    reValidateMode: "onChange",
    // defaultValues: DEFAULT_VALUES,
  });

  const onCellValueChange = (event: any, rowIndex: number, field: any) => {
    // const updatedData = [...tableData];

    // updatedData[rowIndex][event.field] = field;

    // setTableData(updatedData);
    setTableData((prev: any) => {
      const updatedData = [...prev];
      const updatedRow = { ...updatedData[rowIndex], [event.field]: field };
      updatedData[rowIndex] = updatedRow;
      setSelectedItems((prevSelected: any[]) =>
        prevSelected
          .map(sel => updatedData.find(r => r.client_id === sel.client_id))
          .filter(Boolean)
      );
      return updatedData;
    });
  };
  const onSubCellValueChange = (event: any, rowIndex: number, field: any, parentId: number) => {

    // const updatedData = [...subtableData];

    // updatedData[rowIndex][event.field] = field;

    // setSubTableData(updatedData);
    console.log('fieldsdgvsgvsgd', field)
    setSubTableData((prev: any) => {
      const updatedData = [...prev];
      const updatedRow = { ...updatedData[rowIndex], [event.field]: field };
      updatedData[rowIndex] = updatedRow;
      console.log('updatedData', updatedData)
      setSelectedSubItems((prevSelected: any[]) =>
        prevSelected
          .map(sel => updatedData.find(r => r.client_id === sel.client_id))
          .filter(Boolean)
      );
      console.log('parentId', parentId)
      console.log('updatedData', updatedData)
      const result = tableData.map((item: any) =>
        item.client_id === parentId
          ? { ...item, children: updatedData }
          : item
      );
      console.log('result', result)
      setTableData(result)
      return updatedData;
    });
  };


  console.log('tableData123123', tableData)


  const onSubmit = (formData: any) => {
    // alert("submit clicked")
    setFormSubmitted(true)
    // const hasNullSelectedItems = selectedItems && selectedItems.length > 0 ? selectedItems.some((row: any) => {
    // 
    //     if(row.roles && row.timeProfiles){
    //       return true
    //     } else {
    //       return false
    //     }
    // }) : true

    // const hasNullSelectedSubItems = selectedSubItems && selectedSubItems.length > 0 ? selectedSubItems.some((row: any) => {
    //   
    //   for(let i = 0; i < row.length; i++){

    //     if(row.client_roles && row.client_time_profiles){
    //         return true
    //       } else {
    //           return false
    //         }
    //       }
    // }) : true

    const hasNullSelectedItems = selectedItems.length === 0 || selectedItems.every(
      (item: any) => item.hasOwnProperty("roles") && item.hasOwnProperty("timeProfiles")
    );
    // const hasNullSelectedSubItems = selectedSubItems.length > 0 && selectedSubItems.every(
    //   (item:any) => item.hasOwnProperty("client_roles") && item.hasOwnProperty("client_time_profiles")
    // );
    const hasNullSelectedSubItems = selectedSubItems.length === 0 || selectedSubItems.every(
      (item: any) => item.hasOwnProperty("client_roles") && item.hasOwnProperty("client_time_profiles")
    );


    if (hasNullSelectedItems && hasNullSelectedSubItems) {
      // alert("else")
      setFormSubmitted(false)


      // let allSelectedAccountantsAndClients = []
      // Merge the two arrays
      let allSelectedAccountantsAndClients: any[] = [...selectedItems, ...selectedSubItems];
      console.log('allSelectedAccountantsAndClients', allSelectedAccountantsAndClients)

      // for (let i = 0; i < selectedItems.length && i < selectedSubItems.length; i++) {


      //   // Merge properties from selectedItems[i] and selectedSubItems[i]
      //   mergedData.push({
      //     ...selectedItems[i],
      //     ...selectedSubItems[i],
      //   });
      // }

      // Flatten the array of arrays into a single array
      // mergedData = mergedData.flat();



      let finalDataOfAllSelectedItems = []
      for (let i = 0; i < allSelectedAccountantsAndClients.length; i++) {
        finalDataOfAllSelectedItems.push({
          // "firstName": formData.name1,
          // "lastName": formData.name2,
          // "timezone": "(GMT-08:00) Pacific Time (US & Canada)",
          "variableValue": allSelectedAccountantsAndClients[i].client_name,
          "timeProfileId": allSelectedAccountantsAndClients[i].timeProfiles ? parseInt(allSelectedAccountantsAndClients[i].timeProfiles) : allSelectedAccountantsAndClients[i].client_time_profiles,
          "roleId": allSelectedAccountantsAndClients[i].roles ? parseInt(allSelectedAccountantsAndClients[i].roles) : allSelectedAccountantsAndClients[i].client_roles,
          // "email": formData.email,
          // "applicationId": 20
        });
      }
      // ]

      let payload = {
        "firstName": formData.name1,
        "lastName": formData.name2,
        "timezone": "(GMT-08:00) Pacific Time (US & Canada)",
        "userDetail": finalDataOfAllSelectedItems,
        "email": formData.email,
        "applicationId": 20
      }

      onDataSubmit(payload)
    } else {
      // alert("true")
    }
  }


  const renderErrorClass = (field: any, rowIndex: number, rowData: any) => {

    // if(rowData.client_id === 223){
    //   return 'error-input'
    // }
    let result = "input-dropdown-fields";

    selectedItems.forEach((selectedItem: any) => {
      const matchingItem = tableData.find((item: any) => item.client_id === selectedItem.client_id);
      if (matchingItem && formSubmitted) {
        // Check if roles and timeProfiles are available in newData
        if (matchingItem.roles) {
          result = "input-dropdown-fields";
        } else {
          if (field.field === "roles" && matchingItem.client_id === rowData.client_id) {
            result = "error-input input-dropdown-fields";
          }
        }

        if (matchingItem.timeProfiles) {
          result = "input-dropdown-fields";
        } else {
          if (field.field === "timeProfiles" && matchingItem.client_id === rowData.client_id) {
            result = "error-input input-dropdown-fields";
          }
        }
      } else {
        // If no matchingItem found
        result = "input-dropdown-fields";
      }
    });

    return result
  }
  const renderSubItemErrorClass = (field: any, rowIndex: number, rowData: any) => {
    let result = "input-dropdown-fields";

    selectedSubItems.forEach((selectedItem: any) => {
      const matchingItem = subtableData.find((item: any) => item.client_id === selectedItem.client_id);
      if (matchingItem && formSubmitted) {
        // Check if roles and timeProfiles are available in newData
        if (matchingItem.client_roles) {
          result = "input-dropdown-fields";
        } else {
          if (field.field === "client_roles" && matchingItem.client_id === rowData.client_id) {
            result = "error-input input-dropdown-fields";
          }
        }

        if (matchingItem.client_time_profiles) {
          result = "input-dropdown-fields";
        } else {
          if (field.field === "client_time_profiles" && matchingItem.client_id === rowData.client_id) {
            result = "error-input input-dropdown-fields";
          }
        }
      } else {
        // If no matchingItem found
        result = "input-dropdown-fields";
      }
    });


    return result
  }

  const columnsBody = (rowData: any, row: any, x: any) => {

    if (x.field === "roles") {
      return (
        <Dropdown
          options={roles && roles}
          value={rowData.roles}
          onChange={(e: any) => onCellValueChange(x, row.rowIndex, e.value)}
          placeholder="--"
          className={renderErrorClass(x, row.rowIndex, rowData)}
        />
      )
    }
    if (x.field === "timeProfiles") {
      return (
        <Dropdown
          options={timeProfiles && timeProfiles}
          value={rowData.timeProfiles}
          onChange={(e: any) => onCellValueChange(x, row.rowIndex, e.value)}
          placeholder="--"
          className={renderErrorClass(x, row.rowIndex, rowData)}
        />
      )
    }
    return (
      <td role="cell" style={{ fontSize: "0.875rem" }}>{rowData[x.field]}</td>
    )
  }

  const columnsSubBody = (rowData: any, row: any, x: any, parentId: number) => {

    if (x.field === "client_roles") {
      return (
        <Dropdown
          options={roles && roles}
          value={rowData.client_roles}
          onChange={(e: any) => onSubCellValueChange(x, row.rowIndex, e.value, parentId)}
          placeholder="--"
          className={renderSubItemErrorClass(x, row.rowIndex, rowData)}
        />
      )
    }
    if (x.field === "client_time_profiles") {
      return (
        <Dropdown
          options={timeProfiles && timeProfiles}
          value={rowData.client_time_profiles}
          onChange={(e: any) => onSubCellValueChange(x, row.rowIndex, e.target.value, parentId)}
          placeholder="--"
          className={renderSubItemErrorClass(x, row.rowIndex, rowData)}
        />
      )
    }
    return (
      <td role="cell" style={{ fontSize: "0.875rem" }}>{rowData[x.field]}</td>
    )
  }

  // const [hasAcc, setHasAcc] = useState(false)
  const rowExpansionTemplate = (data: any) => {

    console.log('subtableData', subtableData)
    console.log('data.children', data.children)
    if (data && data.children) {
      // if (!subtableData) {
      setSubTableData(data.children);
      // } else if (!isEqual(data.children, subtableData)) {
      //   // setSubTableData(data.children);
      // }
      console.log('data.id', data)
      const parentId = data.id;

      // const tableData =
      //   subtableData[data.client_id] ?? data.children;
      // console.log('tableData', tableData)
      // if (!isEqual(data.children, subtableData)) {
      //   setSubTableData(data.children);
      // }


      // if (hasAccountant) {
      //   setHasAcc(true)
      // } else {
      //   setHasAcc(false)
      // }
    }
    const hasAccountant = selectedItems.some((item: any) => item.client_name === data.client_name);
    const parentId = data.client_id
    return (
      <div className="p-3">
        <DataTable
          lazy value={data.children}
          key={tableData}
          selection={selectedSubItems}
          onSelectionChange={(e: any) => setSelectedSubItems(e.value)}
          className={hasAccountant ? "p-disabled SubItemsDataTable" : "SubItemsDataTable"}
          selectionMode={'checkbox'}
        >
          <Column
            selectionMode="multiple"
            frozen
            resizeable={false}
            style={{ width: "34px" }}
            field="selection"
            columnKey="selection"
          ></Column>
          {clientHeaderColumns &&
            clientHeaderColumns.map((x: any, index: any) => {
              return (
                <Column
                  key={index}
                  field={x.field}
                  header={x.headerName}
                  body={(rowData: any, row: any) => columnsSubBody(rowData, row, x, parentId)}
                />
              );
            })}
        </DataTable>
      </div>
    );
  };


  const onResetClicked = () => {
    formMethods.reset();
  };

  const footer = () => {
    return (
      <div style={{ textAlign: "center", margin: "10px 0" }}>
        <SubmitButton
          label="Invite User"
          testId="submit-button"
          loading={false}
          icon={<PlaylistAddCheckOutlinedIcon />}
          variant={SubmitButtonVariant.Primary}
        />
        <ResetButton testId="reset-button" onClickHandler={onResetClicked} />
      </div>
    );
  };
  console.log("rows", rows)
  console.log("expandedRows", expandedRows)
  console.log("columns", columns)
  console.log("selectedItems", selectedItems)
  console.log("selectedSubItems", selectedSubItems)

  const onSelectionModelChange = useCallback(
    (e: any) => {
      setSelectedItems(e.value)
    }, [])

  return (
    <div className="card">
      <Toast ref={toast} />
      <FormProvider {...formMethods}>
        <form onSubmit={formMethods.handleSubmit(onSubmit)}>
          <Box sx={{ width: "50%", marginBottom: "50px" }}>

            <RHookFormTextFieldWithLabel
              label="First Name"
              id="name1"
              testId={`first-name`}
              labelPosition={LabelPosition.Left}
              required
              labelColumns={4}
              fieldColumns={8}
            />
            <RHookFormTextFieldWithLabel
              label="Last Name"
              id="name2"
              testId={`last-name`}
              labelPosition={LabelPosition.Left}
              required
              labelColumns={4}
              fieldColumns={8}
            />
            <RHookFormTextFieldWithLabel
              label="Email"
              id="email"
              testId={`email`}
              labelPosition={LabelPosition.Left}
              required
              labelColumns={4}
              fieldColumns={8}
            />

          </Box>
          <DataTable value={rows && tableData}
            key={tableData}
            expandedRows={expandedRows}
            lazy
            onRowToggle={(e: any) => setExpandedRows(e.data)}
            rowExpansionTemplate={rowExpansionTemplate}
            dataKey="client_name"
            selection={selectedItems}
            onSelectionChange={onSelectionModelChange}
            selectionMode={'checkbox'}
            footer={footer}
            loading={isLoading}
            editMode="cell"
          >
            <Column
              selectionMode="multiple"
              frozen
              resizeable={false}
              style={{ width: "34px" }}
              field="selection"
              columnKey="selection"
            ></Column>

            <Column expander={allowExpansion} style={{ width: '35px' }} />
            {columns &&
              columns.map((x: any, index: any) => {
                return (
                  <Column
                    key={index}
                    field={x.field}
                    header={x.headerName}
                    body={(rowData: any, row: any) => columnsBody(rowData, row, x)}
                  />
                );
              })}
          </DataTable>
        </form>
      </FormProvider>
    </div>
  );
}